import {
  BirdviewCardPlaceholder,
  BirdviewState,
  checkIsBirdviewEmptyState,
} from '../../../../DashboardBirdview'

export function getOverviewPanelBody({ children, emptyText, state }) {
  return checkIsBirdviewEmptyState(state) ? (
    <BirdviewCardPlaceholder>{emptyText}</BirdviewCardPlaceholder>
  ) : (
    children
  )
}

export function getOverviewPanelCardState(state) {
  return checkIsBirdviewEmptyState(state) ? BirdviewState.Normal : state
}
